const CONSTANTS = {
    APIBASEURL: 'https://demoapi.onblick.com',
    APPLICATIONBASEURL: 'https://demoess.onblick.com',
    WEBURL: "https://demoess.onblick.com",
    WSO2BASEURL: 'https://demo.onblick.com',
    I539BASEURL: 'https://demo-i539api.onblick.com',
    PDFEMBEDAPICLIENTKEY : "70130ff17df94c8c8aac11af72c3106a",
    WSO2LOGOUTURL: 'https://demo.onblick.com/account/onblicklogoff',
    CDNIMAGESBASEURL:"https://demohrmscdn.onblick.com"

}

export default CONSTANTS


// WEBPACK FOOTER //
// ./src/components/Core/constants.js